import React from 'react';

export const PERCENTAGE_LEFT_ICON: React.ReactElement = <span>%</span>;
